import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  href?: string;
  className?: string;
  variant?: 'primary' | 'white';
}

// eslint-disable-next-line import/prefer-default-export
export function Logo({ href, className = '', variant = 'primary' }: LogoProps) {
  const textColor = variant === 'white' ? 'text-white' : 'text-primary';

  const content = (
    <div>
      <div className="flex items-center">
        <span className="font-display text-tertiary">Boost</span>
        <span className="font-display ml-0.5">Hiring</span>
        <sup className="text-[0.7em] align-super mt-4 ml-0.5 font-normal">&trade;</sup>
      </div>
    </div>
  );

  const baseClasses = `text-4xl font-bold tracking-tighter ${textColor} group ${className}`;

  if (href) {
    return (
      <Link to={href} className={baseClasses}>
        {content}
      </Link>
    );
  }

  return <div className={baseClasses}>{content}</div>;
}
